import React, {Component} from 'react';
import {withModal} from './context';

class ModalComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      closingRequest: false
    };

    this.closeDialog = this.closeDialog.bind(this);
    this.closeRequest = this.closeRequest.bind(this);
  }

  componentDidMount() {

    this._isMounted = true;
    if (this._isMounted) {
      this.props.modal.getData
        .subscribe(resp => {

          this.setState({
            modal: resp,
            closingRequest: true
          });
        });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.props.modal.getData.unsubscribe();
  }

  closeDialog(e) {
    this.setState({
      closingRequest: false
    });

    setTimeout(() => {
      this.props.modal.close();
    }, 350);

    e.preventDefault();
  }

  closeRequest() {
    this.state({
      closingRequest: true
    });
  }

  render() {
    const {modal} = this.state;

    return (
      <div>
        {modal
          ? <div className={'modal-layout ' + (this.state.closingRequest ? 'modal-layout--active' : '')}>
            <div className={'modal-body ' + (this.state.closingRequest ? 'modal-body--active' : '')}>
              <div className="title-line">
                <h4>{modal.name}</h4>
                <div onClick={this.closeDialog} className="close-button">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                       x="0px" y="0px"
                       viewBox="0 0 95.939 95.939">
                    <g>
                      <path fill={'#FFF'} d="M62.819,47.97l32.533-32.534c0.781-0.781,0.781-2.047,0-2.828L83.333,0.586C82.958,0.211,82.448,0,81.919,0
                      c-0.53,0-1.039,0.211-1.414,0.586L47.97,33.121L15.435,0.586c-0.75-0.75-2.078-0.75-2.828,0L0.587,12.608
                      c-0.781,0.781-0.781,2.047,0,2.828L33.121,47.97L0.587,80.504c-0.781,0.781-0.781,2.047,0,2.828l12.02,12.021
                      c0.375,0.375,0.884,0.586,1.414,0.586c0.53,0,1.039-0.211,1.414-0.586L47.97,62.818l32.535,32.535
                      c0.375,0.375,0.884,0.586,1.414,0.586c0.529,0,1.039-0.211,1.414-0.586l12.02-12.021c0.781-0.781,0.781-2.048,0-2.828L62.819,47.97
                      z"/>
                    </g>
                  </svg>
                </div>
              </div>
              <div className="body-area">
                {modal.modal}
              </div>
            </div>
            <div className="modal-layer" onClick={this.closeDialog}></div>
          </div>
          : null
        }
      </div>
    );
  }
}

export default withModal(ModalComponent);
